import { Link } from 'react-router-dom';

/**
 * Shared shell for auth flow pages.
 *
 * Consistent nav + footer means signup, verify, verify-pending, and login
 * all feel like the same product. Kept deliberately simple — this isn't
 * the dashboard, it's a three-step conversion surface.
 *
 * The footer signature mirrors the marketing site's new convention:
 * "Built by SE Digital · a Tocyn Ltd product · Made in Wales"
 */
export function AuthShell({ children }) {
  return (
    <div className="auth-shell">
      <header className="auth-nav">
        <div className="container auth-nav-inner">
          <Link to="/" className="brand-lockup" aria-label="TocynID home">
            <span className="brand-tocyn">Tocyn</span>
            <span className="brand-id">ID</span>
          </Link>
          <nav aria-label="Account">
            {/*
              Intentional minimal nav for auth pages. Cross-links only:
              signup → login, login → signup. No marketing nav — if the user
              wants pricing, they tap the TocynID brand which returns them
              to the public marketing site (via client-side /) which is
              actually just the signup landing until we link out properly.
              Phase 2 will add richer nav in the dashboard.
            */}
            <a
              href="https://tocynid.com"
              className="btn btn-ghost"
              style={{ fontSize: 'var(--fs-sm)' }}
            >
              Back to tocynid.com
            </a>
          </nav>
        </div>
      </header>

      <main className="auth-main">
        <div className="container container-narrow">
          {children}
        </div>
      </main>

      <footer className="auth-footer">
        <div className="container">
          Built by{' '}
          <a
            href="https://digital.systematic-edge.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            SE Digital
          </a>
          {' '}· a{' '}
          <a
            href="https://find-and-update.company-information.service.gov.uk/company/17141975"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tocyn Ltd
          </a>
          {' '}product · Made in Wales
        </div>
      </footer>
    </div>
  );
}
